module.exports = __webpack_public_path__ + "static/media/LogoBlack.641199dc.svg";